import { HttpClient } from '@angular/common/http';
import { Component, QueryList, ViewChildren } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from "@angular/forms";
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
/**
 * Food data with nested structure.
 * Each node has a name and an optional list of children.
 */
interface FoodNode {
  id: number;
  name: string;
  type: string;
  children?: FoodNode[];
}



/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  type: string;
  id: number;
}


@Component({
  standalone: true,
  imports: [MatTreeModule, MatButtonModule, MatIconModule, CommonModule,ReactiveFormsModule],
  selector: 'app-kb-article-category',
  templateUrl: './article-kb.component.html',
  styleUrl: './article-kb.component.scss'
})



export class KBShowComponent {

  TREE_DATA: FoodNode[] = [];
  htmlContent: string = '';
  articleTitle: string = '';
  createdDate: string = '';
  idArtigo: string = '';
  // public headers: QueryList<BasicDataTableDirective>;

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      id: node.id,
      name: node.name,
      type: node.type,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  public searchForm: FormGroup;
  avaliacaoEnviada: boolean = false;
  isLoading: boolean = false; // Nova variável para controlar o estado de carregamento

  
  constructor( private fb: FormBuilder,  public router: Router, private http: HttpClient,  private toastr: ToastrService, private route: ActivatedRoute) {
    this.searchForm = this.fb.group({
      searchtext: ["", Validators.required],
      domain: ["", Validators.required],
      comentario: ["", Validators.required],
      avaliacao: [null, Validators.required],
      idArtigo: ["", Validators.required],
      
    });
    
    const menu = this.route.snapshot.paramMap.get('menu');
    if(menu != null && menu != undefined)
    {
        this.loadhierarchy(menu);
        //Carregando Pagina
        const id = this.route.snapshot.paramMap.get('id');
        if(id != null && id != undefined)
        {
          this.idArtigo = id;
          this.loadArticle(id);
        }
    }
    else
    {
      alert("Favor verificar se o link esta correto");
    }
  };

  send() {
    const params = { q: this.searchForm.value["searchtext"] };
      this.router.navigate(['/kb/search'], { queryParams: params });
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  loadArticle(id: any){

    this.http.get<any>(`${environment.apiUrl}/kb/${id}/article` ).subscribe(
      (response) => {
        this.avaliacaoEnviada = false;
        this.articleTitle = response.title;
        this.createdDate = response.createdDate;
        this.htmlContent  = response.htmlContent;
        this.idArtigo = id;
        console.log(response);

      },
      (error) => {
        console.error('Error:', error);
      });
  }

  loadhierarchy(menu: string){

    this.http.get<any>(`${environment.apiUrl}/kb/${menu}` ).subscribe(
      (response) => {
        this.dataSource.data  = response;
        //this.treeControl.expandAll();
        console.log(response);

      },
      (error) => {
        console.error('Error:', error);
      });
  }



  avaliar(positivo: boolean) {
    this.searchForm.patchValue({ avaliacao: positivo });
    console.log(this.searchForm.value["avaliacao"]);
    console.log(this.searchForm.value["comentario"]);
  }

  enviarAvaliacao() {
    this.isLoading = true; // Inicia o estado de carregamento

    const data = {
      idArtigo: this.idArtigo,
      avaliacao: this.searchForm.value["avaliacao"],
      comentario: this.searchForm.value["comentario"]
    };

    console.log(data);

    this.http.post(`${environment.apiUrl}/knowledgebase/article/survey`, data).subscribe(
      (response) => {
        console.log('Avaliação enviada com sucesso!', response);
        // Exibe o Toastr com a mensagem de sucesso
        this.toastr.success('Avaliação enviada com sucesso!');

        // Esconde o formulário e exibe a mensagem final
        this.avaliacaoEnviada = true;
        this.isLoading = false; // Finaliza o estado de carregamento  
      },
      (error) => {
        console.error('Erro ao enviar a avaliação', error);
        this.isLoading = false; // Finaliza o estado de carregamento
      }
      
    );
  }


}

